import { merge } from "@visactor/vutils";

import { DEFAULT_THEME, theme } from "./theme";

import { registerGroup } from "@visactor/vrender-kits/register/register-group";

import { registerRect } from "@visactor/vrender-kits/register/register-rect";

import { registerSymbol } from "@visactor/vrender-kits/register/register-symbol";

import { registerText } from "@visactor/vrender-kits/register/register-text";

export function loadPoptipComponent() {
    registerGroup(), registerText(), registerSymbol(), registerRect();
}

export function setPoptipTheme(defaultPoptipTheme) {
    merge(theme.poptip, DEFAULT_THEME, defaultPoptipTheme);
}
//# sourceMappingURL=register.js.map
